import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-welcome-navbar',
  imports: [RouterLink],
  templateUrl: './welcome-navbar.html',
  styleUrl: './welcome-navbar.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeNavbar {
  private router = inject(Router);

  currentRoute = signal<string>(this.router.url);
}
